import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { EncrDecrService } from '../../services/encr-decr.service';
import { SoaImageService } from '../../services/soa-image.service';
import { ContactService } from '../../services/contact.service';
import { environment } from '../../../environments/environment.prod';
import { saveAs } from 'file-saver';
import { ProfessionalService } from './../../services/professional.service';


class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: 'app-time-total',
  templateUrl: './time-total.component.html',
  styleUrls: ['./time-total.component.css']
})
export class TimeTotalComponent implements OnInit {

  loaderMode: boolean = false;
  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  currentUserRole: any = '';

  customer_id: any = '';
  date_month: any = '';
  start_date: any = '';
  end_date: any = '';
  reportCsvPath: any = '';
  isStartDateDisabled: boolean = true;
  isEndDateDisabled: boolean = true;
  endMinDate: any = '';
  startmaxDate: any = '';
  customerFilter: object = [];
  dropdownList: any;
  myDate: any = new Date();
  professional_id: any;
  abc: string;
  tableColumns: any = [];
  tableOrder: any = [];
  reportList: any = [];
  totalRow: any = [];
  regular_hour: any = 0;
  overtime_hour: any = 0;
  regular_hour_rate: any = 0;
  overtime_hour_rate: any = 0;
  double_hour: any = 0;
  double_hour_rate: any = 0;

  //search and select
  dropdownList1: { id: number; itemName: string; }[];
  selectedItems1: { id: number; itemName: string; }[];
  dropdownSettings1: { showCheckbox: boolean; singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; classes: string; };
  //search and select
  dropdownList1pro: { id: number; itemName: string; }[];
  selectedItems1pro: { id: number; itemName: string; }[];
  dropdownSettings1pro: { showCheckbox: boolean; singleSelection: boolean; text: string; selectAllText: string; unSelectAllText: string; enableSearchFilter: boolean; classes: string; };

  enableEdit = false;
  enableEditIndex = 'no';
  model: any = {};
  pro_unique_id: any;

  constructor(
    private http: HttpClient,
    private _soaImage: SoaImageService,
    private _contact: ContactService,
    private EncrDecr: EncrDecrService,
    private _router: Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private datePipe: DatePipe,
    private _professional: ProfessionalService
  ) { }


  dtOptionsList: DataTables.Settings = {};

  ngOnInit() {
    // console.log('enableEditIndex', this.enableEditIndex);
    // console.log('enableEdit', this.enableEdit);

    this.myDate = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');
    this.loaderMode = true;

    this.abc = localStorage.getItem('currentUser');
    var obj = JSON.parse(this.abc);
    this.currentUserRole = localStorage.getItem('role_name');
    this.isStartDateDisabled = true;
    this.isEndDateDisabled = true;
    this.date_month = 'this_week';

    const customerModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
    }
    const data = {
      APIKEY: this.APIKEY,
      company_id: this.company_id,
    }
    //get mobile folder customer list
    this._soaImage.getMobileFiltterData(customerModal)
      .subscribe(
        res => {
          var i = 0;
          for (let item of res.data.customers) {
            {
              // console.log(item['customer_id']);
              this.dropdownList1.push({ 'id': item['customer_id'], 'itemName': item['company_name'] });
            }
            i++;
          }
        },
      );

    this._professional.getProfessionalList(data)
      .subscribe(
        res => {
          var i = 0;
          for (let item of res.data) {
            {
              this.dropdownList1pro.push({ 'id': item['item_id'], 'itemName': item['item_text'] });
            }
            i++;
          }
        },
      );

    this.dropdownList1 = [];
    this.selectedItems1 = [];
    this.dropdownSettings1 = {
      showCheckbox: false,
      singleSelection: true,
      text: "All Customers",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: " "
    };

    this.dropdownList1pro = [];
    this.selectedItems1pro = [];
    this.dropdownSettings1pro = {
      showCheckbox: false,
      singleSelection: true,
      text: "All Professional",
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      enableSearchFilter: true,
      classes: " "
    };

    this.loadDatatable();
  }


  enableEditRow(e, i) {
    this.enableEdit = true;
    this.enableEditIndex = i;
  }

  cancelEditRow() {
    this.enableEdit = false;
    this.enableEditIndex = 'no';
    $('#dataTables_example').DataTable().draw();
  }

  saveEditRow() {
    var editId = $("#editId").val();
    var editHoursWorked = $("#editHoursWorked").val();
    var editCalculated = $("#editCalculated").val();
    var editCostRate = $("#editCostRate").val();
    var editTotal = $("#editTotal").val();
    var edittotalsale = $("#edittotalsale").val();
    var mobile_image_header_id = $("#mobile_image_header_id").val();
    this.model['APIKEY'] = this.APIKEY;

    this.model['user_id'] = this.user_id;
    this.model['company_id'] = this.company_id;
    this.model['mobile_invoice_item_id'] = editId;
    this.model['hours_worked'] = editHoursWorked;
    this.model['calculated'] = editCalculated;
    this.model['cost_rate'] = editCostRate;
    this.model['total'] = editTotal;
    this.model['total_cost'] = editTotal;
    this.model['total_sale'] = edittotalsale;
    this.model['mobile_image_header_id'] = mobile_image_header_id;
    this._professional.updateTimeTotal(this.model)
      .subscribe(
        res => {
          if (res.status == true) {
            $('#dataTables_example').DataTable().draw();

            this.enableEdit = false;
            this.enableEditIndex = 'no';

            this.toastr.success(res.message, 'Success');
          }
          else {
            this.toastr.error(res.message, 'Error');
          }//this._router.navigate(['/customer/customer-list/active']);
        },
      );

  }
  onChangeCustomer(value) {
    this.loaderMode = true;
    this.customer_id = value.id;
    $('#dataTables_example').DataTable().draw();
  }

  onChangeProfessional(value) {
    this.loaderMode = true;
    // console.log(value);
    this.professional_id = value.id;
    $('#dataTables_example').DataTable().draw();
  }

  onChangeDateMonth(value) {
    this.date_month = value;
    if (this.date_month == 'custom') {
      this.isStartDateDisabled = false;
      this.loaderMode = false;
      this.startmaxDate = this.myDate;
    } else {
      this.loaderMode = true;
      this.isStartDateDisabled = true;
      this.isEndDateDisabled = true;
      $("#txtStartDate").val('');
      $("#txtEndDate").val('');
      $('#dataTables_example').DataTable().draw();
    }

  }

  onChangeStartDate(value) {
    this.loaderMode = true;
    this.start_date = value;
    this.isEndDateDisabled = false;
    this.endMinDate = this.start_date;

    if (this.end_date == '') {
      $("#txtEndDate").val(this.myDate);
    }
    $('#dataTables_example').DataTable().draw();
  }

  onChangeEndDate(value) {
    this.loaderMode = true;
    this.end_date = value;
    $('#dataTables_example').DataTable().draw();
  }

  loadDatatable() {
    this.loaderMode = false;
    this.tableColumns = [{ data: 'customer.company_name' }, { data: 'professional.pro_unique_id' },{ data: 'professional.professional_name' }, { data: 'professional.pro_unique_id' }, { data: 'mobile_image_header.work_week' }, { data: 'time_total.date_worked' }, { data: 'product_line.speciality' }, { data: 'professional.empl_type' }, { data: 'mobile_image_header.	invoice_number_item' }, { data: 'product_line.work_type' }, { data: 'time_total.hours_worked' }, { data: 'time_total.calculated' }, { data: 'product_line.cost_rate' }, { data: 'time_total.total_cost' }, { data: 'time_total.total_sale' }];
    this.tableOrder = [[2, 'asc']];

    this.dtOptionsList = {
      pagingType: 'full_numbers',
      pageLength: 100,
      lengthMenu: [25, 50, 100, 150],
      columnDefs: [{
        'targets': [12,13,14], // column index (start from 0)
        'orderable': false, // set orderable false for selected columns
      }],
      order: this.tableOrder,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.minNumber = dataTablesParameters.start + 1;
        dataTablesParameters.maxNumber = dataTablesParameters.start + dataTablesParameters.length;
        dataTablesParameters.APIKEY = this.APIKEY;
        dataTablesParameters.user_id = this.user_id;
        dataTablesParameters.company_id = this.company_id;
        dataTablesParameters.status = 'active';
        dataTablesParameters.customer_id = this.customer_id;
        dataTablesParameters.professional_id = this.professional_id;
        dataTablesParameters.pro_unique_id = this.pro_unique_id;

        dataTablesParameters.date_month = this.date_month;
        dataTablesParameters.start_date = this.start_date;
        dataTablesParameters.end_date = this.end_date;

        this.http
          .post<DataTablesResponse>(
            environment.api + '/Report/getTimeTotalAjax',
            dataTablesParameters
          )
          .subscribe((resp: any) => {
            this.loaderMode = false;

            if (resp.status == true) {
              this.reportList = resp.data;
              console.log("tessst", this.reportList);
              let regular_cal = 0;
              let regular_hour_cal = 0;
              let overtime_cal = 0;
              let overtime_hour_cal = 0;
              let double_cal = 0;
              let double_hour_cal = 0;
              for (let i = 0; i < this.reportList.length; i++) {
                if (this.reportList[i].work_type == 'Regular') {
                  regular_cal = regular_cal * 1 + 1 * this.reportList[i].calculated;
                  regular_hour_cal = regular_hour_cal * 1 + 1 * this.reportList[i].total_cost;
                } else if (this.reportList[i].work_type == 'Overtime') {
                  overtime_cal = overtime_cal * 1 + 1 * this.reportList[i].calculated;
                  overtime_hour_cal = overtime_hour_cal * 1 + 1 * this.reportList[i].total_cost;
                }
                else if (this.reportList[i].work_type == 'Double') {
                  double_cal = double_cal * 1 + 1 * this.reportList[i].calculated;
                  double_hour_cal = double_hour_cal * 1 + 1 * this.reportList[i].total_cost;
                } else { }
              }
              this.regular_hour = regular_cal;
              this.regular_hour_rate = regular_hour_cal;
              this.overtime_hour = overtime_cal;
              this.overtime_hour_rate = overtime_hour_cal;
              this.double_hour = double_cal;
              this.double_hour_rate = double_hour_cal;
              this.totalRow = resp.total;
            } else if (resp.status == false) {
              this.regular_hour = 0;
              this.regular_hour_rate = 0;
              this.overtime_hour = 0;
              this.overtime_hour_rate = 0;
              this.double_hour = 0;
              this.double_hour_rate = 0;

            }
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: []
            });
          });
      },
      columns: this.tableColumns
    };
  }

  downloadReportCsvTimeTotal() {
    this.loaderMode = true;
    const reportModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      status: 'active',
      customer_id: this.customer_id,
      professional_id: this.professional_id,
      pro_unique_id: this.pro_unique_id,
      date_month: this.date_month,
      start_date: this.start_date,
      end_date: this.end_date,
    }
    //get mobile folder list 
    this._soaImage.downloadReportCsvTimeTotal(reportModal)
      .subscribe(
        res => {
          this.loaderMode = false;
          this.reportCsvPath = res.url;
          this.forceDownload(this.reportCsvPath);
        },
      );
  }
  forceDownload(url) {
    var fileName = url.substring(url.lastIndexOf("/") + 1, url.length);
    //console.log('CSV fileName' , fileName) ;
    this.http.get(url, { responseType: 'blob' }).subscribe(
      (d: any) => {
        saveAs(d, fileName);
      },
      (err: any) => {
        console.log("error", err)
      }
    )

  }
  //calculation 
  calualtedHourtoDecimal(value12, lineid) {
    var i = 0;
    this.reportList.forEach(element => {

      if (element.mobile_invoice_item_id == lineid) {
        var value = value12;
        if (value == '') {
          value = '0:00:00';
        }

        // alert(value12);
        var hours_multiplier = 1;
        var minute: any = '';
        var second: any = '';
        var str_new_second: any = '';
        // console.log(value.indexOf('-'));
        if (value.indexOf('-') != -1) {

          hours_multiplier = (-1) * hours_multiplier;
        }
        if (value.indexOf(':') != -1) {

          var hours1 = 0;
          if (value.split(':')[0] != '')
            hours1 = parseInt(value.split(':')[0], 10);
          var minute_m = parseInt(value.split(':')[1], 10);
          var second_m = parseInt(value.split(':')[2], 10);

          if (minute_m) {
            minute_m = minute_m;
            var str_new = value.split(':')[1].length;
          } else {
            minute_m = 0;
            str_new = 1;
          }

          if (second_m) {
            second_m = second_m;
            str_new_second = value.split(':')[2].length;
          } else {
            second_m = 0;
            str_new_second = 1;
          }
          //if(str_new>1){ var minute=minute_m;} else {var minute=minute_m+'0';}
          if (str_new > 1) {
            if (minute_m * 1 > 59) {
              alert('Hours worked minutes can not be greater than 59 mins.');
              var minute_m = 0;
              var hours1 = 0;
              var hours_multiplier = 0;
              var calculated: any = 0;
              element.hours_worked = "0:00:00";
              $("#hours_worked" + lineid).val("0:00:00");
              // document.getElementById("hours_worked" + lineid).focus();
            } minute = minute_m;
          }
          else {
            minute = '0' + minute_m;
            second = second_m;
            // $("#hours_worked"+lineid).val(hours1+':'+minute);
            element.hours_worked = hours1 + ':' + minute + ':' + second;
          }
          var hours = (hours1);
          //console.log(second_m);
          if (str_new_second > 1) {
            if (second_m * 1 > 59) {
              alert('Hours worked second  can not be greater than 59 seconds.');
              var minute_m = 0;
              var hours1 = 0;
              var hours_multiplier = 0;
              var calculated: any = 0;
              element.hours_worked = "0:00:00";
              $("#hours_worked" + lineid).val("0:00:00");
              //document.getElementById("hours_worked" + lineid).focus();
            }
            second = second_m;
          }
          else {
            second = '0' + second_m;
            //minute=minute_m+'0';
            // $("#hours_worked"+lineid).val(hours1+':'+minute);
            element.hours_worked = hours1 + ':' + minute + ':' + second;
            //element.hours_worked=hours1+':'+minute;
          }

          if (isNaN(minute)) {
            var minu = '00';
          } if (isNaN(second)) {
            var seco = '00';
          }
          var min1 = (minute / 60);
          var min: any = ((min1).toFixed(2));
          var sec1 = (second / 3600);
          var sec: any = ((sec1).toFixed(2));
          if ((hours * 1) > 0) {
            // console.log(hours * 1, min * 1, sec * 1);
            calculated = (hours * 1 + min * 1 + sec * 1).toFixed(2);
          }
          else {
            calculated = -((hours * 1 - min * 1 - sec * 1).toFixed(2));
          }
          //	hours=hours2*1;
          var fin: any = (hours_multiplier * calculated).toFixed(2);
          var todigit: any = 0;
          if (fin % 1 == 0) {
            todigit = parseFloat(fin);
            fin = todigit.toFixed(2);
          }
          element.calculated = fin;
          $("#calculated" + lineid).val((fin));
          if (value.split(':')[0] == '' && value.split(':')[1] != '') {
            $("#hours_worked" + lineid).val('00:' + value.split(':')[1]);
            element.hours_worked = '0:' + value.split(':')[1];
          }
        }
        else {
          if ($("#hours_worked" + lineid).val() == '') {
            element.calculated = 0;
            $("#calculated" + lineid).val(0);
            $("#hours_worked" + lineid).val(0);
            element.hours_worked = '0:00:00';
          }
          else if ($("#hours_worked" + lineid).val() == '-') {
            element.calculated = 0;
            $("#calculated" + lineid).val(0);
            $("#hours_worked" + lineid).val('0:00:00');
            element.hours_worked = '0:00:00';
          }
          else {
            var val = (value * 1);
            element.calculated = val;
            $("#calculated" + lineid).val((val));
            $("#hours_worked" + lineid).val(val + ':00:00');
            element.hours_worked = val + ':00:00';
          }
        }
        if (minute * 1 > 59) {
          element.calculated = 0;
          $("#calculated" + lineid).val(0);

          element.hours_worked = "0:00:00";
        }
        if (second * 1 > 59) {
          element.calculated = 0;
          $("#calculated" + lineid).val(0);
          $("#hours_worked" + lineid).val("0:00:00");
          element.hours_worked = "0:00:00";
        }
      }
    });
    this.discount_individual('sdh', lineid);
  }

  calualtedDecimaltoHour(value12, lineid) {
    var i = 0;
    this.reportList.forEach(element => {
      if (element.mobile_invoice_item_id == lineid) {
        var value: any = value12;
        if (value == '') {
          value = '0.00';

          element.calculated = '0.00';
        }
        var hours_multiplier = 1;
        var minute: any = '';
        var second: any = '';
        var str_new_second: any = '';
        var hours1 = 0;
        if (value.split('.')[0] != '')
          hours1 = parseInt(value.split('.')[0], 10);
        var minute_m = parseInt(value.split('.')[1], 10);
        var hours = (hours1);
        var totalmin: any = '';
        if (isNaN(minute_m)) {
          totalmin = '00';
        } else {
          var minn: any = '0.' + minute_m;
          var min1: any = ((minn * 1) * 60);
          min1 = min1 + '';
          totalmin = parseInt(min1.split('.')[0], 10);
          //var totalsecond=sec
          second = parseInt(min1.split('.')[1], 10);
        }
        if (isNaN(second)) {
          totalsecond = '00';
        } else {
          var secc: any = '0.' + second;
          var sec1 = ((secc * 1) * 60);
          //var totalsecond=sec
          var totalsecond: any = ((sec1).toFixed(2));
          totalsecond = totalsecond + '';
          totalsecond = parseInt(totalsecond.split('.')[0], 10);
        }

        if (totalsecond == 0) {
          totalsecond = '00';
        }
        if (totalmin == 0) {
          totalmin = '00';
        }
        var final_hour: any = hours + ':' + totalmin + ':' + totalsecond;
        element.hours_worked = final_hour;
        element.calculated = value12;
      }
      i++;
    });
    //  this.submitForm.get('dynamicFields').setValue(this.submitForm.value.dynamicFields);
    this.discount_individual('sdh', lineid);
  }

  discount_individual(str, lineid) {
    // added by archana 19june2023
    var sale_rate: any = 0.0;
    var total_sale: any = 0.0;
    var qty: any = 0.0;
    var price: number = 0.0;
    var total: any = 0.0;
    var items: any = 0.0;
    var subtotal: any = 0.0;
    var sub_tax: any = 0;
    var total_taxamount: any = 0;
    var subtotal: any = 0;
    var i = 0;
    var todigit: any = '';
    var todigit1: any = '';
    this.reportList.forEach(element => {

      if (element.mobile_invoice_item_id == lineid) {
        qty = element.calculated;
        price = element.cost_rate;
        sale_rate = element.sale_rate;
        total_sale = element.total_sale;
        var qt1: any = element.hours_worked;
        // alert(qt1.charAt(1));
        if (qt1.charAt(1) == 'a' || qt1.charAt(1) == '-' || qt1.charAt(2) == '-' || qt1.charAt(3) == '-' || qt1.charAt(4) == '-' || qt1.charAt(5) == '-' || qt1.charAt(6) == '-') {

          $("#hours_worked" + str).val(0)
          $("#calculated" + str).val(0)
          element.calculated = 0;
          element.hours_worked = "0:00:00";
          qty = 0;
          //return false;
        }
        total = ((qty * price)).toFixed(2);
        if (total % 1 == 0) {
          todigit = parseFloat(total);
          total = todigit.toFixed(2);
        }
        total_sale = ((qty * sale_rate)).toFixed(2);
        if (total_sale % 1 == 0) {
          todigit1 = parseFloat(total_sale);
          total_sale = todigit1.toFixed(2);
        }
        var checkk = isNaN(total);
        if (checkk == true) {
          total = 0;
        }
        var checkk1 = isNaN(total_sale);
        if (checkk1 == true) {
          total_sale = 0;
        }
        element.total = total;
        element.total_cost = total;
        element.total_sale = total_sale;
        i++;
      }
    });

    if (subtotal % 1 == 0) {
      todigit = parseFloat(subtotal);
      subtotal = todigit.toFixed(2);
    }
    var checkka = isNaN(total_taxamount);
    if (checkka == true) {
      total_taxamount = 0.00;
    } if (total_taxamount % 1 == 0) {
      todigit = parseFloat(total_taxamount);
      total_taxamount = todigit.toFixed(2);
    }
    var grand_total: any = (subtotal * 1 + total_taxamount * 1).toFixed(2);
    var checkkab = isNaN(grand_total);
    if (checkkab == true) {
      grand_total = 0.00;
    }
    if (grand_total % 1 == 0) {
      todigit = parseFloat(grand_total);
      grand_total = todigit.toFixed(2);
    }
  }


  discount_individualForCostRate(cost_rate, lineid) {
    var qty: any = 0.0;
    var price: number = 0.0;
    var total: any = 0.0;
    var items: any = 0.0;
    var subtotal: any = 0.0;
    var sub_tax: any = 0;
    var total_taxamount: any = 0;
    var subtotal: any = 0;
    var i = 0;
    var todigit: any = '';
    this.reportList.forEach(element => {
      if (element.mobile_invoice_item_id == lineid) {
        qty = element.calculated;
        price = cost_rate;
        var qt1: any = element.hours_worked;
        // alert(qt1.charAt(1));
        if (qt1.charAt(1) == 'a' || qt1.charAt(1) == '-' || qt1.charAt(2) == '-' || qt1.charAt(3) == '-' || qt1.charAt(4) == '-' || qt1.charAt(5) == '-' || qt1.charAt(6) == '-') {
          element.calculated = 0;
          element.hours_worked = "0:00:00";
          qty = 0;
          //return false;
        }
        total = ((qty * price)).toFixed(2);
        if (total % 1 == 0) {
          todigit = parseFloat(total);
          total = todigit.toFixed(2);
        }
        var checkk = isNaN(total);
        if (checkk == true) {
          total = 0;
        }
        element.total = total;
        element.total_cost = total;
        i++;
      }
    });

    if (subtotal % 1 == 0) {
      todigit = parseFloat(subtotal);
      subtotal = todigit.toFixed(2);
    }
    var checkka = isNaN(total_taxamount);
    if (checkka == true) {
      total_taxamount = 0.00;
    }

    if (total_taxamount % 1 == 0) {
      todigit = parseFloat(total_taxamount);
      total_taxamount = todigit.toFixed(2);
    }
    var grand_total: any = (subtotal * 1 + total_taxamount * 1).toFixed(2);
    var checkkab = isNaN(grand_total);
    if (checkkab == true) {
      grand_total = 0.00;
    }
    if (grand_total % 1 == 0) {
      todigit = parseFloat(grand_total);
      grand_total = todigit.toFixed(2);
    }

  }
  onlynumberic(evt) {
    // Only ASCII charactar in that range allowed 
    var ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //alert(ASCIICode);
    if ((ASCIICode >= 48 && ASCIICode <= 58 || ASCIICode == 45))
      return true;
    return false;
  }

  onlynumbericnegative(event) {
    var charCode = (typeof event.which == "number") ? event.which : event.keyCode;
    var typedChar = String.fromCharCode(charCode);
    if (typedChar == "-" && event.target.value == "") {
      return;
    }
    if ((event.which != 46 || event.target.value.indexOf('.') != -1) &&
      ((event.which < 48 || event.which > 57) && (event.which != 45 || event.target.value.indexOf('-') != -1) &&
        (event.which != 0 && event.which != 8))) {
      event.preventDefault();
    }
    var text = event.target.value;
    if ((text.indexOf('.') != -1) &&
      (text.substring(text.indexOf('.')).length > 2) &&
      (event.which != 0 && event.which != 8)
    ) {
      event.preventDefault();
    }
  }

  OnItemDeSelect(item: any) {
    // console.log(item);
  }
  onDeSelectAll(items: any) {
    // console.log('professional unselect' + items);
    this.professional_id = '';
    $('#dataTables_example').DataTable().draw();
  }
  onDeSelectAllCust(items: any) {
    // console.log('customer unselect' + items);
    this.customer_id = '';
    $('#dataTables_example').DataTable().draw();
  }
}
